import './GatewayContent.scss';

import { LinksFooter } from './LinksFooter';
import { LoadingSpinner } from '@ui/LoadingSpinner';
import { useNavigate } from 'react-router-dom';

import React, { PropsWithChildren } from 'react';

export const GatewayContent: React.FC<PropsWithChildren> = ({ children }) => {
	const navigate = useNavigate();

	return (
		<div className='gateway'>
			<div className='content'>
				<div
					className='arovy-logo clickable'
					onClick={ () => navigate('/') } />
				{ children ? children : <LoadingSpinner
					size='large'
					spinning /> }
			</div>
			<LinksFooter />
		</div>
	);
};
